export default function PrivacyPolicyPage() {
    return (
        <>
            <div className="hero">
                <div className="container">
                    <h1 className="hero-title">Política de Privacidade</h1>
                    <p className="hero-description hero-description-wide">
                        Sua privacidade é importante para nós. Esta política de privacidade explica como coletamos, usamos e protegemos suas informações pessoais quando você utiliza nosso site e serviços.
                    </p>
                </div>
            </div>
        </>
    )
}